import React, { FC } from 'react';
import { Anchor, AnchorMode } from '@components/atoms/Anchor';
import { Container } from '@components/atoms/Container';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import styles from '../Menu.module.css';

interface MenuItemLinkProps {
    id: string;
    label: string;
    linkTo: string;
    show: boolean;
}

/**
 * Directly links to a page (example: link to Contacts page).
 * Used on Navigation component.
 */
export const MenuItemLink: FC<MenuItemLinkProps> = ({ id, label, linkTo, show }) => {
    return (
        <div id={id} className={`nav-item ${styles['nav-item']} ${show ? 'd-block' : 'd-none'}`}>
            <Anchor href={linkTo} mode={AnchorMode.none} classes={`nav-link ${styles['nav-link']}`}>
                <Container classes={styles.container}>
                    <Typography tagVariant={TypographyTagVariants.span}>{label}</Typography>
                </Container>
            </Anchor>
        </div>
    );
};
